import { Link } from "react-router-dom";
import { PageLayout } from "@/components/PageLayout";
import { CalculatorCard } from "@/components/CalculatorCard";
import { calculators } from "@/data/calculators";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Heart, Search } from "lucide-react";
import { Button } from "@/components/ui/button";
import logoLight from "@/assets/logo-light_t.png";
import logoDark from "@/assets/logo-dark_t.png";
import { useTranslation } from "react-i18next";
import { SEO } from "@/components/SEO";
import { useLanguageAwareSEO } from "@/hooks/useLanguageAwareSEO";
import { breadcrumbSchema, calculatorToolSchema } from "@/utils/structuredData";

export default function Health() {
  const { t } = useTranslation();
  const healthCalculators = calculators.filter(calc => calc.category === "general" && calc.subcategory === "Health");

  // Set up language-aware structured data
  useLanguageAwareSEO([
    (lang) => breadcrumbSchema([
      { name: "Home", url: "https://calclab.app" },
      { name: t('categories.pages.health.title'), url: "https://calclab.app/health" }
    ], lang)
  ]);

  return (
    <PageLayout>
      <SEO 
        title={`${t('categories.pages.health.title')} - CalcLab`}
        description={t('categories.pages.health.description')}
        keywords="health calculator, BMI calculator, BMR calculator, body fat calculator, TDEE calculator, ideal weight calculator, macro calculator"
      />
      <div className="space-y-8">
        <div className="text-center space-y-4">
          <div className="flex justify-center">
            <Heart className="h-16 w-16 text-primary" />
          </div>
          <h1 className="text-4xl font-bold tracking-tight">{t('categories.pages.health.title')}</h1>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
            {t('categories.pages.health.description')}
          </p>
        </div>

        <Card className="border-primary/20">
          <CardHeader>
            <CardTitle>{t('categories.pages.health.cardTitle')}</CardTitle>
            <CardDescription>
              {t('categories.pages.health.cardDescription')}
            </CardDescription>
          </CardHeader>
          <CardContent>
            <p className="text-muted-foreground">
              {t('categories.pages.health.cardContent')}
            </p>
          </CardContent>
        </Card>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {healthCalculators.map(calculator => (
            <CalculatorCard key={calculator.id} {...calculator} />
          ))}
        </div>
      </div>
    </PageLayout>
  );
}
